/**
 * @see https://aframe.io/docs/1.3.0/introduction/visual-inspector-and-dev-tools.html
 */
export var Inspector = function Inspector(_ref) {
  var _this = this;

  var url = _ref.url;

  this.toString = function () {
    var _this$url;

    return _this.url ? "url:" + ((_this$url = _this.url) == null ? void 0 : _this$url.toString()) + ";" : '';
  };

  this.url = url;
};